// extracted by mini-css-extract-plugin
export default {"loadingContainer":"NewOrderLoadingEmployee_loadingContainer__Fpr3F","loadingSpinner":"NewOrderLoadingEmployee_loadingSpinner__bK+7Z","spin":"NewOrderLoadingEmployee_spin__3nce7"};